import { useEffect, useState } from 'react';
import { Box, TextField, Autocomplete, Stack, Typography} from '@mui/material';
import { Text } from 'mbd-components/text';


const EndpointTag = (props) => {
  const nameMap = {
    'casts/feed/trending': 'trending',
    'casts/feed/for-you': 'for you',
    'casts/feed/popular': 'popular'
  }
  const colorMap = {
    'casts/feed/trending': '#475569',
    'casts/feed/for-you': '#7b68e3',
    'casts/feed/popular': '#7F83AA' 
  }
  return (
    <Box px={1} py={0.5} sx={{backgroundColor: colorMap[props.endpoint], borderRadius: 1}}>
      <Text variant='small' color='white'>{nameMap[props.endpoint]}</Text>
    </Box>
  )
}

export function FeedSelector({feeds, templateFeeds, filterOutFeedIds, selectedFeedId, onChange}) {

  const [currentValue, setCurrentValue] = useState(null);
  useEffect(() => {
    if (selectedFeedId) {
      setCurrentValue(filterOutFeedIds?.includes(selectedFeedId) ? null : feeds.find(feed => feed.config_id === selectedFeedId) );
    }
  }, [selectedFeedId,filterOutFeedIds]);

  let allFeeds = [
    ...feeds.sort((a, b) => {
      const numA = parseInt(a.config_id.split('_')[1], 10);
      const numB = parseInt(b.config_id.split('_')[1], 10);
      return numB - numA; // Descending order
    }), 
    ...(templateFeeds || [])
  ];
  
  if (filterOutFeedIds?.length > 0) {
    allFeeds = allFeeds.filter(feed => !filterOutFeedIds.includes(feed.config_id));
  }

  return (
    <Autocomplete
      fullWidth
      value={currentValue}
      onChange={(event, newValue) => {
        if (newValue) {
          onChange(newValue);
        }
      }}
      options={allFeeds}
      getOptionLabel={(option) => option.name + ' (' + option.config_id + ')' || ''}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" margin="dense" />
      )}
      renderOption={(props, option) => 
        <Box {...props} px={2} py={1}>
          <Stack direction='column' spacing={1}>
          <Typography variant="body1" fontWeight="medium">{option.name}</Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }} alignItems={'flex-start'} justifyContent={'flex-start'} justifyItems={'flex-start'}>
            <Typography variant="caption" color="text.secondary" textAlign={'left'}>ID: {option.config_id}</Typography>
            <Typography variant="caption" color="text.secondary" textAlign={'left'}>Endpoint: </Typography>
            <EndpointTag endpoint={option.endpoint}/>
          </Box>
          </Stack>
        </Box>
      }
    />
  );
}